import React from 'react';
import {Outlet, Navigate, useLocation} from 'react-router-dom';
import {getLoggedInUser} from '../../helpers/fakebackend_helper';
import DispatchOverview from '../../pages/Dispatch/dispatch-overview';
import SessionTimeout from '../../pages/Authentication/SessionTimeout';

interface AuthMiddlewareProps {
  requiredRoles?: string[];
  Layout: React.ComponentType<any>;
  component?: React.ComponentType<any>;
}

export const AuthMiddleware: React.FC<AuthMiddlewareProps> = ({
  requiredRoles,
  Layout,
  component: Component,
}) => {
  const location = useLocation();
  const authUser = getLoggedInUser();

  // Not logged in → redirect to login
  if (!authUser || !authUser.user) {
    return <Navigate to="/login" state={{from: location}} replace />;
  }

  // Role not authorized → redirect to dashboard
  if (
    requiredRoles &&
    authUser.user &&
    !requiredRoles.includes(authUser.user.role)
  ) {
    return <Navigate to="/dashboard" replace />;
  }

  // Dispatcher → special layout/component
  if (authUser.user.role === 'dispatcher') {
    return (
      <Layout>
        <SessionTimeout />
        <DispatchOverview />
      </Layout>
    );
  }

  // Default → render requested component
  if (Component) {
    return (
      <Layout>
        <SessionTimeout />
        <Component />
      </Layout>
    );
  }

  // fallback für nested routes
  return (
    <Layout>
      <SessionTimeout />
      <Outlet />
    </Layout>
  );
};
